<template>
  <div class="modern-form-container">
    <!-- Progress Steps -->
    <div class="form-progress mb-4">
      <div class="step-container" :class="`step-${currentStep}`">
        <div class="step col-md-6" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
          <div class="step-number">1</div>
          <span>Informations sur l'étudiant</span>
        </div>
        <div class="step col-md-6" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
          <div class="step-number">2</div>
          <span>Pièces à fournir</span>
        </div>

      </div>
    </div>

    <div class="card modern-card">
      <div class="card-body p-4">
        <Form ref="inscriptionForm" @submit="nextStep" :validation-schema="currentSchema">
          <!-- Step 1: Basic Information -->
          <div :class="{ 'd-none': currentStep !== 1 }" class="step-content">
            <h4 class="step-title mb-4">
              <i class="fas fa-info-circle me-2"></i>
              Informations de l'étudiant
            </h4>
            <div class="row">
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="numeroMatricule" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Numéro Matricule
                  </label>
                  <Field name="numeroMatricule" type="text"
                    class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le numéro" />
                  <ErrorMessage name="numeroMatricule" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="nom" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Nom<span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                    placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="prenom" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Prénom <span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                    placeholder="Entrer le prénom" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="email" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Email <span class="text-danger">*</span>
                  </label>
                  <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                    placeholder="Entrer l'email" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 1 <span class="text-danger">*</span>
                  </label>
                  <Field name="telephone1" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2" />
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
                  <ErrorMessage name="telephone1" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="anneeExperience" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Nombre d'années d'expériences
                  </label>
                  <Field name="anneeExperience" type="number"
                    class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le nombre" />
                  <ErrorMessage name="anneeExperience" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Informations complémentaires <span class="text-danger">*</span>
                  </label>
                  <Field name="biographie" rows="2" as="textarea" placeholder="Ajouter d'autres informations"
                    v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                    <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
                  </Field>
                  <ErrorMessage name="biographie" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="dateNaissance" class="modern-label">
                    <i class="fas fa-calendar me-2"></i>
                    Date de naissance<span class="text-danger">*</span>
                  </label>
                  <Field name="dateNaissance" type="date" :max="currentDate"
                    class="form-control shadow-none fs-md-15 text-black modern-input" />
                  <ErrorMessage name="dateNaissance" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Sexe <span class="text-danger">*</span>
                  </label>
                  <Field name="sexe" type="text" v-slot="{ field }">
                    <Multiselect :searchable="true"
                      :options="[{ label: 'Masculin', value: 'Masculin' }, { label: 'Féminin', value: 'Féminin' }]"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner le sexe" />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-select-group">
                  <label class="modern-label">
                    <i class="fas fa-folder me-2"></i>
                    Niveau <span class="text-danger">*</span>
                  </label>
                  <Field name="niveau" type="text" v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :options="niveauOptions" :preserve-search="true"
                      :multiple="false" :searchable="true" placeholder="Sélectionner le niveau" label="label"
                      track-by="label" />
                  </Field>
                  <ErrorMessage name="niveau" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-select-group">
                  <label class="modern-label">
                    <i class="fas fa-folder me-2"></i>
                    Filière <span class="text-danger">*</span>
                  </label>
                  <Field name="filiere" type="text" v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :options="filiereOptions" :preserve-search="true"
                      :multiple="false" :searchable="true" placeholder="Sélectionner la filière" label="label"
                      track-by="label" />
                  </Field>
                  <ErrorMessage name="filiere" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-select-group">
                  <label class="modern-label">
                    <i class="fas fa-folder me-2"></i>
                    Année académique <span class="text-danger">*</span>
                  </label>
                  <Field name="anneeId" type="text" v-slot="{ field }">
                    <Multiselect v-model="selectedAnnee" v-bind="field" :options="anneeOptions" :preserve-search="true"
                      :multiple="false" :searchable="true" placeholder="Sélectionner l'année académique" label="label"
                      track-by="value" />
                  </Field>
                  <ErrorMessage name="anneeId" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Pays de résidence <span class="text-danger">*</span>
                  </label>
                  <Field name="nationalite" v-model="nationalite" v-slot="{ field }">
                    <Multiselect :options="countries" :searchable="true" track-by="value" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de résidence" />
                  </Field>
                  <ErrorMessage name="nationalite" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Commune <span class="text-danger">*</span>
                  </label>
                  <Field name="commune" v-slot="{ field }">
                    <Multiselect :options="communeOptions" @change="communeChange($event)" :searchable="true"
                      track-by="value" label="label" v-model="selectedCommune" v-bind="field"
                      placeholder="Sélectionner la commune" />
                  </Field>
                  <ErrorMessage name="commune" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Quartier <span class="text-danger">*</span>
                  </label>
                  <Field name="quartier" v-slot="{ field }">
                    <Multiselect :options="quartierOptions" :searchable="true" track-by="value" label="label"
                      v-model="selectedQuartier" v-bind="field" noOptionsText="Sélectionner d'abord une commune"
                      placeholder="Sélectionner le quartier" />
                  </Field>
                  <ErrorMessage name="quartier" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Qualification <span class="text-danger">*</span>
                  </label>
                  <Field name="qualificationId" v-slot="{ field }">
                    <Multiselect :options="qualificationOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la qualification" />
                  </Field>
                  <ErrorMessage name="qualificationId" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Activité <span class="text-danger">*</span>
                  </label>
                  <Field name="activites" v-slot="{ field }">
                    <Multiselect :options="activiteOptions" :searchable="true" mode="tags" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
                  </Field>
                  <ErrorMessage name="activites" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-select-group">
                  <label class="modern-label">
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Parent <span class="text-danger">*</span></span>
                      <span class="btn btn-primary py-1 px-2 fs-12" style="cursor: pointer;" data-bs-toggle="modal"
                        data-bs-target="#AddElementModal" title="Ajouter un nouveau parent">
                        Nouveau
                      </span>
                    </div>
                  </label>
                  <Field name="parent" v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :options="parentsOptions" :preserve-search="true"
                      :multiple="false" :searchable="true" placeholder="Sélectionner le parent" label="label"
                      track-by="label" />
                  </Field>
                  <ErrorMessage name="parent" class="text-danger" />
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Pieces à fournir -->
          <div :class="{ 'd-none': currentStep !== 2 }" class="step-content">
            <h4 class="step-title mb-4">
              <i class="fas fa-tags me-2"></i>
              Pièces à fournir
            </h4>
            <div class="row">

              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                  <div class="row">
                    <div class="border border-primary mb-1">
                      <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                        style="background-color: #0a59a4">
                        <div class="col-md-7">
                          <h3 class="fs-4 text-white">Pièce(s)</h3>
                        </div>
                        <div class="col-md-5">
                          <div class="d-flex float-end">
                            <button
                              class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                              type="button" :class="{ 'cursor-not-allowed': isDisable }" @click="addRowPiece()">
                              <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                              Ajouter une pièce
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <!-- Titres colonnes -->
                        <div class="row gx-1">
                          <div class="col-md-4">
                            <label class="d-block text-black fw-semibold">Type de pièce <span
                                class="text-danger">*</span></label>
                          </div>
                          <div class="col-md-4">
                            <label class="d-block text-black fw-semibold mb-1">Numéro de pièce <span
                                class="text-danger">*</span></label>
                          </div>
                          <div class="col-md-3">
                            <label class="d-block text-black fw-semibold mb-1">Image <span
                                class="text-danger">*</span></label>
                          </div>
                          <div class="col-md-1">
                            <label class="d-block text-black fw-semibold mb-1">Action</label>
                          </div>
                        </div>
                        <hr class="mt-0" />
                        <!-- Boucle sur les pièces -->
                        <div class="row gx-1" v-for="(piece, index) in pieces" :key="index">
                          <!-- Type de pièce -->
                          <div class="col-md-4 mb-3">
                            <div class="modern-select-group">
                              <Field :name="`pieces[${index}].typePiece`" v-slot="{ field }">
                                <Multiselect v-model="pieces[index].typePiece" v-bind="field" :options="typeOptions"
                                  :preserve-search="true" :multiple="false" :searchable="true"
                                  placeholder="Sélectionner le type de pièce" label="label" track-by="value"
                                  class="modern-multiselect" />
                              </Field>
                              <ErrorMessage :name="`pieces[${index}].typePiece`" class="text-danger" />
                            </div>
                          </div>
                          <!-- Numéro de pièce (conditionnel) -->
                          <div class="col-md-4 mb-3" v-if="!isPhotoPiece(pieces[index].typePiece)">
                            <!-- Change 'photo' selon ton libellé -->
                            <div class="modern-input-group">
                              <Field type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                                placeholder="Entrer le numéro de la pièce" :name="`pieces[${index}].numeroPiece`"
                                v-model="pieces[index].numeroPiece" />
                              <ErrorMessage :name="`pieces[${index}].numeroPiece`" class="text-danger" />
                            </div>
                          </div>

                          <!-- Optionnel : message si c'est une photo -->
                          <div class="col-md-4 mb-3" v-else>
                            <small class="text-muted">Aucun numéro requis pour la photo d'identité</small>
                          </div>
                          <!-- Image -->
                          <div class="col-md-3 mb-3">
                            <div class="form-group mb-0">
                              <Field type="file" accept="image/*,application/pdf,application/msword,video/mp4"
                                class="form-control" @change="handleFileChange($event, index)"
                                :name="`pieces[${index}].urlImage`" />
                              <ErrorMessage :name="`pieces[${index}].urlImage`" class="text-danger" />
                            </div>
                          </div>
                          <!-- Bouton suppression -->
                          <div class="col-md-1 mb-3" v-if="index > 0">
                            <button class="btn btn-danger transition border-0 py-1 px-2" type="button"
                              @click="removeRowPiece(index)">
                              <i class="flaticon-delete lh-1 me-0 position-relative top-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="form-navigation mt-4">
            <button type="button" class="btn btn-outline-secondary me-3" @click="previousStep" v-if="currentStep > 1">
              <i class="fas fa-arrow-left me-2"></i>
              Précédent
            </button>
            <button type="submit" v-if="currentStep < 2"
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16">
              Suivant
              <i class="fas fa-arrow-right ms-2"></i>
            </button>
            <button class="btn btn-success me-3" type="submit" v-if="currentStep === 2" :disabled="isSubmitting">
              <i class="fas fa-plus me-2" v-if="!isSubmitting"></i>
              <i class="fas fa-spinner fa-spin me-2" v-if="isSubmitting"></i>
              {{ isSubmitting ? 'Enregistrement en cours...' : 'Enregistrer' }}
            </button>
            <router-link to="/liste-demande-inscriptions"
              class="btn btn-danger border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16">
              <i class="fas fa-times me-2"></i>
              Annuler
            </router-link>
          </div>
        </Form>
      </div>
    </div>
    <br /><br />
    <AddParentModal @close="handleClose" @refresh="loadParents" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed, watch, nextTick } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import { AxiosError } from 'axios';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import AddParentModal from './AddParent.vue';
import { Piece } from '@/models/Piece';
import { countries } from './countries';
import { VueTelInput } from 'vue3-tel-input';

export default defineComponent({
  name: 'AddInscription',
  components: {
    Form,
    Field,
    ErrorMessage,
    AddParentModal,
    Multiselect,
    VueTelInput
  },
  setup: () => {
    const route = useRoute();
    const router = useRouter();

    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const inscriptionForm = ref<any>(null);
    const parents = ref<any[]>([]);
    const parentsOptions = ref([]);
    const niveauOptions = ref([]);
    const filiereOptions = ref([]);
    const typeOptions = ref([]);
    const anneeOptions = ref<{ value: number; label: string }[]>([]);
    //const anneeOptions = ref([]);
    const defaultAnneeId = ref<number | null>(null); // ← ajouter
    const countriesRef = ref(countries);
    const parent = ref(null);
    const currentStep = ref(1);
    const isSubmitting = ref(false);
    const stepLength = ref(2);
    const isDisable = ref(true);


    const nationalite = ref('Bénin');

    const validPhone = ref<boolean>(false);
    const mainFile = ref<File | null>(null);


    interface LocalPiece {
      typePiece: string;
      numeroPiece: string;
      urlImage: File | null;
      existingUrl?: string;
    }

    const pieces = ref<LocalPiece[]>([
      { typePiece: '', numeroPiece: '', urlImage: null, existingUrl: '' }
    ]);

    // const pieces = ref<Piece[]>([{ typePiece: '', numeroPiece: '', urlImage: null, existingUrl: '' }]);
    const qualificationOptions = ref([]);
    const activiteOptions = ref([]);
    const quartierOptions = ref<any[]>([]);
    const selectedQuartier = ref();
    const selectedCommune = ref();
    const communeOptions = ref([]);
    const quartier = ref();
    const commune = ref();
    const telephone1 = ref();

    const demande = ref<any>(null);
    const isEditMode = computed(() => !!route.params.id);

    const getDemandeInscription = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/demandes/${id}`);
        demande.value = data.data;

        console.log('Données de:', data.data);

      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement de l'demande");
      }
    };

    const fillFormWithDemande = async () => {
      if (!demande.value || !inscriptionForm.value) return;

      const d = demande.value;

      // ✅ La commune est dans quartier.arrondissement.commune
      const communeId = d.quartier?.arrondissement?.commune?.id ?? null;
      const quartierId = d.quartier?.id ?? null;


      await nextTick();

      inscriptionForm.value.setValues({
        numeroMatricule: d.numeroMatricule || '',
        nom: d.nom || '',
        prenom: d.prenom || '',
        email: d.email || '',
        telephone1: d.telephone1 || '',
        anneeExperience: d.anneeExperience || 0,
        biographie: d.biographie || '',
        dateNaissance: d.dateNaissance ? d.dateNaissance.split('T')[0] : '',
        sexe: d.sexe || '',
        niveau: d.niveau?.id ?? d.niveau ?? null,
        filiere: d.filiere?.id ?? d.filiere ?? null,
        anneeId: d.annee?.id ?? d.anneeId ?? defaultAnneeId.value, // fallback sur l'année en cours
        nationalite: d.nationalite || 'Bénin',
        qualificationId: d.qualification?.id ?? d.qualificationId ?? null,
        activites: d.activites?.map((a: any) => a.id || a) || [],
        parent: d.parent?.id ?? d.parent ?? null,
        commune: communeId,
        quartier: quartierId,
      });

      console.log(
        'form commune =',
        inscriptionForm.value.values.commune
      );

      console.log(
        'form quartier =',
        inscriptionForm.value.values.quartier
      );

      const anneeId = d.annee?.id ?? d.anneeId ?? defaultAnneeId.value;
      const anneeOption = anneeOptions.value.find(opt => opt.value === anneeId);
      selectedAnnee.value = anneeOption ?? null;

      // Synchroniser le Multiselect commune
      if (communeId) {
        const communeOption = communeOptions.value.find((c: any) => c.value === communeId);
        selectedCommune.value = communeId;
        console.log(' gg selectedCommune=', selectedCommune.value);

        // Charger les quartiers de cette commune
        await communeChange(communeId);
        await nextTick();

        // Synchroniser le Multiselect quartier après chargement
        if (quartierId) {
          console.log('quartierOptions=', quartierOptions.value);
          console.log('type quartierId=', typeof quartierId);
          const quartierOption = quartierOptions.value.find((q: any) => q.value === quartierId);
          selectedQuartier.value = quartierId;
          console.log('quartierId =', quartierId);
          console.log('rrrrrrv quartierOption =', quartierOption);
          console.log('selectedQuartier=', selectedQuartier.value);
          inscriptionForm.value.setFieldValue('quartier', quartierId);
        }
      }

      // Téléphone
      if (d.telephone1) {
        telephone1.value = d.telephone1;
        validPhone.value = true;
      }
    };

    const loadParents = async () => {
      try {
        const { data } = await ApiService.get('/parents');
        parents.value = data.data.data;
        parentsOptions.value = data.data.data.map((parent: any) => ({
          value: parent.id,
          label: `${parent.nom} ${parent.prenom}`,
        }));
      } catch (err) {
        error('Erreur lors du chargement des parents');
      }
    };

    const handleClose = (values) => {
      parent.value = values;
      loadParents();
    };

    const currentSchema = computed(() => {
      return schemas.value[currentStep.value - 1];
    });

    const schemas = computed(() => [
      Yup.object().shape({
        numeroMatricule: Yup.string().notRequired(),
        nom: Yup.string().required('Le nom est obligatoire'),
        prenom: Yup.string().required('Le prénom est obligatoire'),
        email: Yup.string().email('Email invalide').required("L'email est obligatoire"),
        telephone1: Yup.string().required('Le téléphone est obligatoire'),
        dateNaissance: Yup.date()
          .required('La date de naissance est obligatoire')
          .max(new Date(), 'La date de naissance ne peut pas être dans le futur'),
        sexe: Yup.string().required('Le sexe est obligatoire'),
        niveau: Yup.number().required('Le niveau est obligatoire'),
        filiere: Yup.number().required('La filière est obligatoire'),
        anneeId: Yup.number().required("L'année académique est obligatoire"),
        parent: Yup.number().required('Le parent est obligatoire'),
        nationalite: Yup.string().required('La nationalité est obligatoire'),
        anneeExperience: Yup.number().notRequired(),
        commune: Yup.number().required('La commune est obligatoire'),
        quartier: Yup.number().required('Le quartier est obligatoire'),
        qualificationId: Yup.number().required('La qualification est obligatoire'),
        activites: Yup.array().required('Au moins une activité est requise').min(1, 'Sélectionnez au moins une activité'),
      }),
      Yup.object().shape({

        pieces: Yup.array()
          .of(
            Yup.object().shape({
              typePiece: Yup.string().required('Le type de pièce est obligatoire'),
              numeroPiece: Yup.string().when('typePiece', {
                is: (typePiece: string) => typePiece !== '5', // ID de la photo
                then: (schema) => schema.required('Le numéro de pièce est obligatoire'),
                otherwise: (schema) => schema.notRequired().nullable(),
              }),
              urlImage: Yup.mixed().required("L'image est obligatoire"),
            })
          )
          .min(1, 'Au moins une pièce est requise'),
      }),

    ]);

    const nextStep = async (values) => {
      console.log('Valeurs soumises à l\'étape', currentStep.value, ':', values);
      if (currentStep.value === stepLength.value) {
        await addInscription(values, { resetForm: inscriptionForm.value?.resetForm });
        return;
      }
      currentStep.value++;
    };

    const previousStep = () => {
      if (currentStep.value <= 1) return;
      currentStep.value--;
    };

    const addRowPiece = async () => {
      const isValid = await inscriptionForm.value?.validate();
      if (!isValid?.valid) {
        error('Veuillez remplir tous les champs de la pièce actuelle avant d\'en ajouter une nouvelle.');
        return;
      }
      pieces.value.push({
        typePiece: '',
        numeroPiece: '',
        urlImage: null,
        existingUrl: '',
      });
      isDisable.value = true;
    };

    const removeRowPiece = (index: number) => {
      if (pieces.value.length > 1) {
        pieces.value.splice(index, 1);
      }
    };

    const handleFileChange = (event, index) => {
      const file = event.target.files[0];
      pieces.value[index].urlImage = file || null;
      if (file) {
        pieces.value[index].existingUrl = ''; // Effacer l'ancienne URL si nouveau fichier
      }
    };

    const isPhotoPiece = (typeId: string) => {
      // Remplace '5' par l'ID réel de la photo d'identité
      return typeId === '5'; // ou 'photo_identite', selon ton API
    };

    watch(
      pieces,
      async (newValue) => {
        if (newValue.length === 0) {
          isDisable.value = false;
          return;
        }
        const lastPiece = newValue[newValue.length - 1];
        const isValid = await inscriptionForm.value?.validate();
        isDisable.value = !isValid?.valid || !lastPiece.typePiece || !lastPiece.numeroPiece || (!lastPiece.urlImage && !lastPiece.existingUrl);
      },
      { deep: true }
    );

    const fetchCommunes = async () => {
      try {
        const { data } = await ApiService.get('/communes');
        communeOptions.value = data.data.data.map((item: any) => ({
          value: item.id,
          label: item.libelle,
        }));
      } catch (err) {
        error('Erreur lors du chargement des communes');
      }
    };
    const communeChange = async (value: any) => {
      if (!value) {
        quartierOptions.value = [];
        selectedQuartier.value = null;
        return;
      }

      commune.value = value;
      quartierOptions.value = [];
      selectedQuartier.value = null;

      try {
        console.log(`Chargement quartiers pour commune ID: ${value}`);
        const { data } = await ApiService.get(`/communes/quartiers/${value}`);

        quartierOptions.value = data.data.map((q: any) => ({
          label: q.libelle,
          value: q.id,
        }));

        console.log('Quartiers chargés:', quartierOptions.value);
      } catch (err) {
        error('Erreur lors du chargement des quartiers');
        console.error(err);
      }
    };



    watch(selectedQuartier, (newValue) => {
      quartier.value = newValue;
    });



    // Watch pour vérifier le quartier après chargement des options
    watch(quartierOptions, (newOptions) => {
      console.log('communeOptions', communeOptions.value);
      console.log('quartierOptions', quartierOptions.value);
      if (newOptions.length > 0 && selectedQuartier.value !== null) {
        const exists = newOptions.some((opt: any) => opt.value === selectedQuartier.value);
        if (!exists) {
          console.warn('⚠️ Quartier ID non trouvé dans les options:', selectedQuartier.value);
        } else {
          console.log('✅ Quartier trouvé dans les options');
        }
      }
    });

    const validate = (phoneObject) => {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid) {
        telephone1.value = phoneObject.number;
      } else {
        telephone1.value = '';
      }
    };
    const selectedAnnee = ref<{ value: number; label: string } | null>(null);

    // Synchroniser selectedAnnee → vee-validate
    watch(selectedAnnee, (newVal) => {
      if (inscriptionForm.value) {
        inscriptionForm.value.setFieldValue('anneeId', newVal?.value ?? null);
      }
    });

    const addInscription = async (values, { resetForm }) => {
      isSubmitting.value = true;
      try {
        const formData = new FormData();
        formData.append('nom', values.nom);
        formData.append('prenom', values.prenom);
        formData.append('email', values.email);
        formData.append('sexe', values.sexe);
        formData.append('telephone1', telephone1.value || values.telephone1);
        formData.append('dateNaissance', values.dateNaissance);
        formData.append('numeroMatricule', values.numeroMatricule || '');
        formData.append('dateInscription', new Date().toISOString().split('T')[0]);
        formData.append('qualificationId', values.qualificationId);
        formData.append('anneeExperience', values.anneeExperience || '0');
        formData.append('niveau', values.niveau);
        formData.append('filiere', values.filiere);
        formData.append('anneeId', values.anneeId);
        formData.append('nationalite', values.nationalite);
        formData.append('commune', values.commune);
        formData.append('quartier', values.quartier);
        formData.append('parent[id]', values.parent);
        formData.append('demandeId', route.params.id as string);
        if (values.biographie) formData.append('biographie', values.biographie);
        if (values.activites && values.activites.length > 0) {
          formData.append('activites', JSON.stringify(values.activites));
        }

        // Pièces
        const piecesData = pieces.value.map(piece => ({
          typePiece: piece.typePiece,
          numeroPiece: piece.numeroPiece,
        }));
        formData.append('piecesData', JSON.stringify(piecesData));

        pieces.value.forEach((piece, index) => {
          if (piece.urlImage && piece.urlImage instanceof File) {
            formData.append('piecesFichiers', piece.urlImage);
          } else if (piece.existingUrl) {
            formData.append(`piecesExistantes[${index}]`, piece.existingUrl);
          }
        });

        const response = await ApiService.post('/inscriptions', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.code === 201) {
          success(response.data.message);
          resetForm();
          router.push({ name: 'ListeInscriptionPage' });
        }
      } catch (err) {
        const axiosError = err as AxiosError<{ message?: string }>;
        console.error('Erreur lors de l\'enregistrement:', axiosError);
        error(axiosError.response?.data?.message || 'Une erreur est survenue.');
      } finally {
        isSubmitting.value = false;
      }
    };

    const getAllFiliere = async () => {
      try {
        const response = await ApiService.get('/all/filieres');
        filiereOptions.value = response.data.data.data.map((filiere: any) => ({
          value: filiere.id,
          label: filiere.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des filières:', error);
      }
    };

    const getAllType = async () => {
      try {
        const response = await ApiService.get('/all/typePieces');
        typeOptions.value = response.data.data.data.map((type: any) => ({
          value: type.id.toString(),
          label: type.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des types de pièces:', error);
      }
    };

    const getAllNiveaux = async () => {
      try {
        const response = await ApiService.get('/all/niveaux');
        niveauOptions.value = response.data.data.data.map((niveau: any) => ({
          value: niveau.id,
          label: niveau.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des niveaux:', error);
      }
    };
    const getAllAnnees = async () => {
      try {
        const response = await ApiService.get('/all/annees');
        anneeOptions.value = response.data.data.data.map((annee: any) => ({
          value: annee.id,
          label: annee.libelle,
        }));

        // Détecter l'année académique en cours
        const currentYear = new Date().getFullYear();
        const found = anneeOptions.value.find((opt: any) =>
          opt.label.includes(String(currentYear))
        );
        if (found) {
          defaultAnneeId.value = found.value;
        }
      } catch (error) {
        console.error('Erreur lors du chargement des années académiques:', error);
      }
    };



    const fetchQualification = async () => {
      try {
        const response = await ApiService.get('/all/qualifications');
        qualificationOptions.value = response.data.data.data.map((qualification) => ({
          value: qualification.id,
          label: qualification.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des qualifications:', error);
      }
    };

    const fetchActivite = async () => {
      try {
        const response = await ApiService.get('/all/activites');
        activiteOptions.value = response.data.data.data.map((activite) => ({
          value: activite.id,
          label: activite.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des activités:', error);
      }
    };

    const getAllParents = async () => {
      try {
        const response = await ApiService.get('/parents');
        parentsOptions.value = response.data.data.data.map((parent: any) => ({
          value: parent.id,
          label: `${parent.nom} ${parent.prenom}`,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des parents:', error);
      }
    };

    onMounted(async () => {
      const id = route.params.id as string;

      await Promise.all([
        getAllParents(),
        getAllFiliere(),
        getAllType(),
        getAllNiveaux(),
        getAllAnnees(),
        fetchActivite(),
        fetchQualification(),
        loadParents(),
        fetchCommunes(),
      ]);

      // Pré-sélection année en cours (mode création uniquement)
      if (!id && defaultAnneeId.value && inscriptionForm.value) {
        // Passer l'objet complet { value, label } car le Multiselect utilise track-by="label"
        const anneeOption = anneeOptions.value.find(opt => opt.value === defaultAnneeId.value);
        if (anneeOption) {
          inscriptionForm.value.setFieldValue('anneeId', anneeOption.value);
        }
      }

      if (id) {
        await getDemandeInscription(id);
        await fillFormWithDemande();
      }
    });

    return {
      currentStep,
      qualificationOptions,
      activiteOptions,
      loadParents,
      addInscription,
      previousStep,
      currentSchema,
      nextStep,
      inscriptionForm,
      niveauOptions,
      handleClose,
      pieces,
      typeOptions,
      quartier, isPhotoPiece,
      countries: countriesRef,
      addRowPiece,
      removeRowPiece,
      handleFileChange,
      isDisable,
      parents,
      isSubmitting,
      nationalite,
      parentsOptions,
      filiereOptions,
      anneeOptions,
      selectedCommune,
      currentDate,
      selectedQuartier,
      quartierOptions,
      communeChange,
      communeOptions,
      commune,
      telephone1,
      validPhone,
      validate,
      mainFile,
      isEditMode,
      demande,
      fillFormWithDemande,

    };
  },
});
</script>

<style scoped>
/* Modern Form Container */
.modern-form-container {
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

.modern-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

/* Progress Steps */
.form-progress {
  margin-bottom: 2rem;
}

.step-container {
  display: flex;
  width: 100%;
  position: relative;
  padding: 0 1rem;
  margin: 0;
  gap: 1rem;
}

.step-container::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 15%;
  right: 15%;
  height: 3px;
  background: linear-gradient(90deg, #e9ecef 0%, #e9ecef 100%);
  border-radius: 2px;
  z-index: 1;
}

.step-container::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 15%;
  height: 3px;
  background: linear-gradient(90deg, #007bff, #28a745);
  border-radius: 2px;
  z-index: 2;
  transition: width 0.6s ease;
  width: 0%;
}

.step-container.step-1::after {
  width: 0%;
}

.step-container.step-2::after {
  width: 50%;
}

.step-container.step-3::after {
  width: 100%;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 0;
  flex: 1;
  max-width: calc(33.33% - 0.75rem);
  text-align: center;
  border-radius: 16px;
  border: 2px solid #e9ecef;
  transition: all 0.4s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin: 0.5rem 0;
}

.step:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 12px;
  transition: all 0.4s ease;
  background: linear-gradient(135deg, #e9ecef, #dee2e6);
  color: #6c757d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 2px solid #ffffff;
}

.step.active {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
  border-color: #007bff;
  transform: translateY(-4px);
  box-shadow: 0 12px 25px rgba(0, 123, 255, 0.15);
}

.step.active .step-number {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
  border-color: #ffffff;
}

.step.completed {
  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
  border-color: #28a745;
  box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);
}

.step.completed .step-number {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
  position: relative;
  border-color: #ffffff;
}

.step.completed .step-number::before {
  content: '✓';
  position: absolute;
  font-size: 20px;
  font-weight: bold;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.step.completed .step-number::after {
  display: none;
}

.step span {
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  text-align: center;
  line-height: 1.3;
  word-wrap: break-word;
  max-width: 100%;
  transition: all 0.3s;
}

.step.active span {
  color: #007bff;
  font-weight: 700;
  transform: scale(1.05);
}

.step.completed span {
  color: #28a745;
  font-weight: 700;
}

/* Modern Inputs */
.modern-input-group,
.modern-select-group {
  position: relative;
  margin-bottom: 1.5rem;
}

.modern-label {
  display: block;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

.modern-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.modern-input:focus {
  outline: none;
  border-color: #FFBE00;
  box-shadow: 0 0 0 0.2rem rgba(255, 190, 0, 0.25);
  transform: translateY(-1px);
}

.modern-multiselect {
  border-radius: 8px !important;
  border: 2px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.modern-multiselect:focus-within {
  border-color: #007bff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  transform: translateY(-1px);
}

.modern-select-group {
  position: relative;
  z-index: 50;
}

.modern-select-group .multiselect--open {
  z-index: 1000;
  position: relative;
}

.modern-multiselect :deep(.multiselect__content-wrapper) {
  z-index: 1001 !important;
  position: absolute !important;
  background: white !important;
  border: 1px solid #e9ecef !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  max-height: 200px !important;
  overflow-y: auto !important;
}

.modern-multiselect :deep(.multiselect__option) {
  padding: 8px 12px !important;
  border-bottom: 1px solid #f8f9fa !important;
}

.modern-multiselect :deep(.multiselect__option:hover) {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
}

.modern-multiselect :deep(.multiselect__option--selected) {
  background: #007bff !important;
  color: white !important;
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 0.25rem;
  display: block;
}

.form-navigation {
  display: flex;
  justify-content: start;
  margin-left: 15px;
  align-items: center;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  position: relative;
  overflow: hidden;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, #57da75, #039a38);
}

.btn-success {
  background: linear-gradient(135deg, #34cc57, #05855f);
  border: 2px solid #28a745;
  color: white;
}

.btn-success:hover {
  background: linear-gradient(135deg, #218838, #1ea085);
  border-color: #1e7e34;
}

.btn-outline-secondary {
  border: 2px solid #6c757d;
  color: #6c757d;
  background: transparent;
}

.btn:disabled {
  opacity: 0.6 !important;
  transform: none !important;
  cursor: not-allowed !important;
}

@media (max-width: 768px) {
  .modern-form-container {
    padding: 1rem 0.5rem;
  }

  .step-container {
    flex-direction: column;
    gap: 1rem;
    padding: 0 0.5rem;
  }

  .step-container::before,
  .step-container::after {
    display: none;
  }

  .step {
    flex-direction: row;
    max-width: 100%;
    padding: 1rem 1.5rem;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border-radius: 12px;
    margin-bottom: 0;
    border: 2px solid #e9ecef;
    justify-content: flex-start;
    text-align: left;
  }

  .step-number {
    margin-bottom: 0;
    margin-right: 1rem;
    width: 40px;
    height: 40px;
    font-size: 14px;
    flex-shrink: 0;
  }

  .step span {
    font-size: 15px;
    text-align: left;
    flex: 1;
    text-transform: none;
    letter-spacing: normal;
  }

  .step-content {
    min-height: 300px;
    padding: 0.5rem;
  }

  .form-navigation {
    flex-direction: column;
    gap: 0.5rem;
  }

  .form-navigation .btn {
    width: 100%;
    max-width: 200px;
  }
}
</style>